export const siteStorageName = "crunchorder";
export const sessionIsAuthenticatedName = "sessionIsAuthenticated";